import { Button } from "@egaranti/components";

import React, { useMemo } from "react";

import { STEPS } from "../constants";
import { getNavigationConfig } from "../constants/navigationConfig";

const Navigation = ({
  step,
  setStep,
  file,
  isProcessing,
  isSubmitting,
  isMappingComplete,
  processData,
  handleSubmit,
  processedData = [],
  validationErrors = [],
  isDataDirty = false,
}) => {
  // Memoize navigation config to prevent recreation on every render
  const navConfig = useMemo(
    () =>
      getNavigationConfig({
        file,
        isProcessing,
        isSubmitting,
        isMappingComplete,
        processData,
        handleSubmit,
        setStep,
      }),
    [
      file,
      isProcessing,
      isSubmitting,
      isMappingComplete,
      processData,
      handleSubmit,
      setStep,
    ],
  );

  const forwardButtonProps = useMemo(() => {
    const props = navConfig.forwardButton[step];
    if (!props) {
      // Fallback to prevent runtime errors
      return {
        onClick: () => {},
        disabled: true,
        loading: false,
        primary: false,
        Icon: undefined,
        text: "",
      };
    }
    return props;
  }, [navConfig.forwardButton, step]);

  const backButtonProps = useMemo(() => {
    if (!navConfig.backButton) {
      // Fallback to prevent runtime errors
      return {
        disabled: true,
        onClick: () => {},
        children: "",
        variant: "secondaryGray",
        Icon: undefined,
      };
    }
    return {
      disabled: navConfig.backButton.disabled(step),
      onClick: navConfig.backButton.onClick(step),
      children: navConfig.backButton.text(step),
      variant: "secondaryGray",
      Icon: navConfig.backButton.icon,
    };
  }, [navConfig.backButton, step]);

  const showBackButton = step !== STEPS.FILE_UPLOAD;
  const showEditButton = step === STEPS.DATA_VALIDATION;

  return (
    <div className="mt-6 flex items-center justify-between">
      <div>
        {showBackButton && (
          <Button
            variant={backButtonProps.variant}
            onClick={backButtonProps.onClick || (() => {})}
            disabled={backButtonProps.disabled}
            Icon={backButtonProps.Icon}
          >
            {backButtonProps.children}
          </Button>
        )}
      </div>
      <div className="flex gap-2">
        {showEditButton && (
          <Button
            variant="secondaryGray"
            onClick={() => setStep(STEPS.COLUMN_MAPPING)}
            disabled={isSubmitting}
            Icon={backButtonProps.Icon}
          >
            Düzenle
          </Button>
        )}
        <Button
          onClick={forwardButtonProps.onClick}
          disabled={
            forwardButtonProps.disabled ||
            (step === STEPS.DATA_VALIDATION &&
              (processedData.length === 0 ||
                (validationErrors && validationErrors.length > 0) ||
                isDataDirty))
          }
          loading={forwardButtonProps.loading}
          primary={forwardButtonProps.primary}
          Icon={forwardButtonProps.Icon}
        >
          {forwardButtonProps.text}
        </Button>
      </div>
    </div>
  );
};

export default React.memo(Navigation);
